<template>
  <div class="mb-3">
    <vue-perfect-scrollbar class="col-12">
      <div class="d-flex">
        <b-card
          no-body
          class="mr-2 card__no_shadow accord"
          style="min-width: 300px"
        >
          <div class="card__title" style="width: 300px">
            <span> Tipo </span>
          </div>
          <div class="card__row bg-light-info" style="width: 300px">
            <span>
              {{ nomeDashboard.rubricas }} previst{{ nomeDashboard.letra }}s
            </span>
          </div>
          <div class="card__row bg-light-success" style="width: 300px">
            <span>
              {{ nomeDashboard.rubricas }} realizad{{ nomeDashboard.letra }}s
            </span>
          </div>
          <div class="card__row bg-light-info" style="width: 300px">
            <span>
              {{ nomeDashboard.notas }} previst{{ nomeDashboard.letra }}s
            </span>
          </div>
          <div class="card__row bg-light-success" style="width: 300px">
            <span>
              {{ nomeDashboard.notas }} realizad{{ nomeDashboard.letra }}s
            </span>
          </div>
          <div
            class="card__row bg-yellow-200"
            style="width: 300px"
            v-if="temTotalizador"
          >
            <span> Total previsto </span>
          </div>
          <div
            class="card__row bg-yellow-300"
            style="width: 300px"
            v-if="temTotalizador"
          >
            <span> Total realizado </span>
          </div>
        </b-card>

        <b-card
          no-body
          class="mr-2 card__no_shadow accord"
          style="min-width: 200px"
        >
          <div class="card__title bg-gradient-warning" style="width: 200px">
            <span> Total </span>
          </div>
          <div class="bg-yellow-100 card__row" style="width: 200px">
            <span>
              {{ formatarValor(totalDespesas.custoPrevisto) }}
            </span>
          </div>
          <div class="card__row bg-yellow-100" style="width: 200px">
            <span>
              {{ formatarValor(totalDespesas.custoRealizado) }}
            </span>
          </div>
          <div class="card__row bg-yellow-100" style="width: 200px">
            <span>
              {{ formatarValor(totalDespesas.notaPrevisto) }}
            </span>
          </div>
          <div class="card__row bg-yellow-100" style="width: 200px">
            <span>
              {{ formatarValor(totalDespesas.notaRealizado) }}
            </span>
          </div>
          <div
            class="card__row bg-yellow-200"
            v-if="temTotalizador"
            style="width: 200px"
          >
            <span>
              {{ formatarValor(totalDespesas.totalPrevisto) }}
            </span>
          </div>
          <div
            class="card__row bg-yellow-300"
            v-if="temTotalizador"
            style="width: 200px"
          >
            <span>
              {{ formatarValor(totalDespesas.totalRealizado) }}
            </span>
          </div>
        </b-card>

        <template v-for="(hora, i) in mesesDespesas">
          <b-card
            :key="i"
            no-body
            class="mr-2 card__no_shadow accord"
            style="min-width: 140px"
          >
            <div class="card__title text-center">
              <span>
                {{ hora.text }}
              </span>
            </div>

            <b-tooltip :target="`valor-previsto-${i}`">
              <div v-for="r in hora.rubricasPrevisto.rubricas" :key="r.label">
                <b>{{ r.label }}</b
                >: {{ r.valor }}
              </div>
            </b-tooltip>
            <div :id="`valor-previsto-${i}`" class="card__row bg-light-info">
              <span>
                {{ hora.rubricasPrevisto.total }}
              </span>
            </div>
            <b-tooltip :target="`valor-realizado-${i}`">
              <div
                v-for="r in hora.rubricasRealizado.rubricas"
                :key="`${r.label}2`"
              >
                <b>{{ r.label }}</b
                >: {{ r.valor }}
              </div>
            </b-tooltip>
            <div
              :id="`valor-realizado-${i}`"
              class="card__row bg-light-success"
            >
              <span>
                {{ hora.rubricasRealizado.total }}
              </span>
            </div>
            <div :id="`notas-prevista-${i}`" class="card__row bg-light-info">
              <span>
                {{ hora.notasPrevistas.total }}
              </span>
            </div>
            <div
              :id="`notas-realizada-${i}`"
              class="card__row bg-light-success"
            >
              <span>
                {{ hora.notasRealizadas.total }}
              </span>
            </div>

            <div class="card__row bg-yellow-200" v-if="temTotalizador">
              <span>
                {{ hora.totalPrevisto }}
              </span>
            </div>
            <div class="card__row bg-yellow-300" v-if="temTotalizador">
              <span>
                {{ hora.totalRealizado }}
              </span>
            </div>
            <b-tooltip :target="`notas-prevista-${i}`" placement="bottom">
              <div v-for="nota in hora.notasPrevistas.notas" :key="nota.id">
                <b>{{ nota.tipo }}:</b>
                {{ nota.valor }}
              </div>
            </b-tooltip>
            <b-tooltip :target="`notas-realizada-${i}`" placement="bottom">
              <div v-for="nota in hora.notasRealizadas.notas" :key="nota.id">
                <b>{{ nota.tipo }}:</b>
                {{ nota.valor }}
              </div>
            </b-tooltip>
          </b-card>
        </template>
      </div>
    </vue-perfect-scrollbar>
  </div>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import helpers from "@/common/utils/helpers";
export default {
  props: {
    totalDespesas: {
      required: true,
    },
    mesesDespesas: {
      required: true,
    },
  },
  components: {
    VuePerfectScrollbar,
  },
  methods: {
    formatarValor(valor) {
      return helpers.formatarValor(valor);
    },
  },
  computed: {
    nomeDashboard() {
      if (
        this.$route.name == "projeto-detalhamento-executora-criadora" ||
        this.$route.name == "projeto-detalhamento-executora-associada"
      )
        return {
          rubricas: "Rubricas",
          notas: "Notas fiscais",
          letra: "a",
        };
      else
        return {
          rubricas: "Custos próprios",
          notas: "Investimentos",
          letra: "o",
        };
    },
    temTotalizador: function () {
      return !(
        this.$route.name == "projeto-detalhamento-executora-criadora" ||
        this.$route.name == "projeto-detalhamento-executora-associada"
      );
    },
  },
};
</script>
<style lang=""></style>
